import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'caret-down', 'CaretDown', [["path",{"d":"M6 10l6 6l6 -6h-12","key":"svg-0"}]]);